<template>
    <div
        class="md-property-history fashion"
        v-if="historys && historys.length > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :btmSpacing="btmSpacing"
            :topSpacing="topSpacing"
            :mobileNoMargin="true"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="content-container">
                <div class="list-property-history">
                    <div class="list-header">
                        <span>{{ $t('md-property-history.date') }}</span>
                        <span>{{ $t('md-property-history.event') }}</span>
                        <span>{{ $t('md-property-history.price') }}</span>
                    </div>
                    <div class="list-sub-header">
                        {{ $t('md-property-history.today') }}
                    </div>
                    <ul class="list-box">
                        <li
                            v-for="(item, index) in historys"
                            :key="index"
                            v-show="index < 5 || (index >= 5 && opened)"
                        >
                            <div class="property-date-source">
                                <only-client>
                                    <span class="property-date">{{
                                        $ft.formatDate(item.date, 'MM/dd/yyyy')
                                    }}</span>
                                </only-client>
                                <span class="property-source" :title="source">{{
                                    $t('md-property-history.source',  { source,interpolation: { escapeValue: false }  })
                                }}</span>
                            </div>
                            <span class="property-status">{{
                                $t(`common:${item.event}`)
                            }}</span>
                            <div class="property-price">
                                <span class="price">{{ item.showPrice }}</span>
                                <span
                                    :class="{
                                        'trend-up': item.diff > 0,
                                        'trend-down': item.diff < 0
                                    }"
                                    v-if="item.diff"
                                >
                                    <i class="iconfont icon-angle" />
                                    {{ item.diff > 0 ? '+' : ''
                                    }}{{ item.diff }}%
                                </span>
                            </div>
                        </li>
                    </ul>
                    <div class="list-sub-header" v-show="showPrevRecord">
                        {{ $t('md-property-history.previousRecord') }}
                    </div>
                    <div
                        class="history-more"
                        :class="{ opened: opened }"
                        v-if="historys.length > 5"
                        @click="toggle"
                    >
                        {{
                            opened
                                ? $t('md-property-history.showLess')
                                : $t('md-property-history.showMore')
                        }}
                        <span class="iconfont icon-small-down"></span>
                    </div>
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
export default {
    mixins: [Common]
};
</script>
<style lang="scss">
.md-property-history.fashion {
    --property-history-border-color: #d6dae8;
    --property-history-weak-cue-color: #8b93a7;
    --property-history-second-color: #6f6f85;
    --property-history-first-color: #4a4a60;
}
@import '../index.scss';
</style>
